import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const AddFilterGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);
  return (
    <g fill={'none'} {...(props.group ?? {})}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.78613 9.52148L7.21191 9.0957V8.16113C7.21208 7.8347 7.34239 7.52182 7.57324 7.29102L10.583 4.28125V3.41602H3.41602V4.28125L6.42578 7.29102C6.65653 7.52181 6.78597 7.83477 6.78613 8.16113V9.52148ZM12.083 4.39258C12.0829 4.71916 11.9526 5.03278 11.7217 5.26367L8.71191 8.27344V9.40723C8.71179 9.60597 8.63273 9.79696 8.49219 9.9375L6.56641 11.8633C6.35191 12.0775 6.02915 12.1414 5.74902 12.0254C5.46908 11.9093 5.28626 11.6361 5.28613 11.333V8.27246L2.27637 5.26367C2.07438 5.06169 1.94995 4.79642 1.92188 4.51465L1.91602 4.39258V3.14746C1.91603 2.82086 2.04543 2.50731 2.27637 2.27637L2.36719 2.19531C2.58633 2.01571 2.86164 1.91602 3.14746 1.91602H10.8516C11.1373 1.9161 11.4127 2.01568 11.6318 2.19531L11.7217 2.27637L11.8037 2.36719C11.9832 2.58631 12.083 2.86171 12.083 3.14746V4.39258ZM10.5827 10.5827V9.33268C10.5827 8.91847 10.9185 8.58268 11.3327 8.58268C11.7469 8.58268 12.0827 8.91847 12.0827 9.33268V10.5827H13.3327C13.7469 10.5827 14.0827 10.9185 14.0827 11.3327C14.0827 11.7469 13.7469 12.0827 13.3327 12.0827H12.0827V13.3327C12.0827 13.7469 11.7469 14.0827 11.3327 14.0827C10.9185 14.0827 10.5827 13.7469 10.5827 13.3327V12.0827H9.33268C8.91847 12.0827 8.58268 11.7469 8.58268 11.3327C8.58268 10.9185 8.91847 10.5827 9.33268 10.5827H10.5827Z"
        fill={fillColor}
      />
    </g>
  );
};

export const AddFilterSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <AddFilterGroup {...props} />
    </svg>
  );
};
